import Vue from "vue";
import VueRouter from "vue-router";
import auth from "@/utils/auth";
import api from "@/api";
import store from "@/store";
import { Notification } from "element-ui";
import $axios from "@/plugins/axios";


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "login",
        component: () =>
            import("@/views/login.vue"),
    },
    {
        path: "/home",
        name: "home",
        component: () =>
            import("@/layout/Index.vue"),
        hideInMenu: true,
        children: [
            {
                path: "/index",
                name: "index",
                component: () =>
                    import("@/views/index.vue"),
                // meta: { breadcrumb: ["首页"], title: "首页" },
            },
            {
                path: "/detail",
                name: "detail",
                component: () =>
                    import("@/views/detail/index.vue"),
            },
            {
                path: "/evaluation",
                name: "evaluation",
                component: () =>
                    import("@/views/evaluation/index.vue"),
            },
            {
                path:"/report",
                name:"report",
                component: () =>
                    import("@/views/report/index.vue"),
            },
            {
                path: "/my",
                name: "my",
                component: () =>
                    import("@/views/my/index.vue"),
            },
        ]
    },
    {
        path:"/taskDetail",
        name:"taskDetail",
        component: () =>
            import("@/views/taskDetail/index.vue"),
    },
    {
        path:"/answerPage",
        name:"answerPage",
        component: () =>
            import("@/views/answerPage/index.vue"),
    },
    {
        path:"/go/:id",
        name:"go",
        component: () =>
            import("@/views/go.vue"),
    }
];

const router = new VueRouter(
    {
        mode: "history",
        base: process.env.BASE_URL,
        routes,
    }
);

router.selfaddRoutes = function (params) {
    router.matcher = new router().matcher;
    router.routes(params)
}
/**
 * 将组件字符串路径转换为异步组件
 * @param {string} menuUrl 组件的字符串路径
 * @returns {promise}
 */

function lazyLoading(menuUrl) {
    return () =>
        import(`@/views${menuUrl}/index.vue`).catch((err) => {
            // 未找到组件
            // console.error(`页面加载错误，未在'${menuUrl}'下找到有效页面！`)
            return import("@/components/ErrorPage.vue");
        });
}


router.beforeEach((to, from, next) => {
    // api.log.routerLog({
    //     routeUrl: to.path
    // }).then(res => {
    // });
    if (to.path == '/') {
        next({
            path: "/index"
        })
    } else {
        // 判断该路由是否需要登录权限
        if (to.meta.requireAuth) {
            // 通过vuex state获取当前的token是否存在
            if (auth.beforeEach()) {
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath }// 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            next();
        }
    }
});

router.afterEach((to) => {
    window.scrollTo(0, 0);
});

export default router;
